import React, { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'

import IconX from '~/components/icons/IconX'

const splitTitle = (input) => {
  return input.split('_').join(' ')
}

const order = [
  'model',
  'colour',
  'external_leds',
  'power_consumption',
  'size_and_weight',
  'grow_leds',
  'processor',
  'app',
  'climate_control',
  'electrical_and_operating_requirements',
  'connectivity',
  'certifications'
]

const sizeAndWeightOrder = { height: 1, width: 2, depth: 3, weight: 4 }
const electricalAndOperatingRequirementsOrder = {
  line_voltage: 1,
  operating_temperature: 2,
  relative_humidity: 3
}

export default function ProductDetails(props) {
  const [specsOpen, setSpecsOpen] = useState(true)

  const techSpecs = props.data.tech_specs

  return (
    <div className="pb-16">
      <h1 className="text-xl lg:text-3xl pb-12 text-white mt-8">
        Technical Specs
      </h1>
      <div
        className={`flex flex-col font-sans-serif text-base font-normal border-t border-grey-300 ${
          !specsOpen && 'border-b pb-4'
        }`}
      >
        <div className="lg:hidden flex flex-row justify-between items-center text-white text-base pt-4 pr-0.5">
          {specsOpen && (
            <motion.div
              initial={{ opacity: 0.75 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1 }}
              onClick={() => setSpecsOpen(!specsOpen)}
              className="cursor-pointer"
            >
              Show Less
            </motion.div>
          )}
          {!specsOpen && (
            <motion.div
              initial={{ opacity: 0.75 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1 }}
              onClick={() => setSpecsOpen(!specsOpen)}
              className="cursor-pointer"
            >
              Show More
            </motion.div>
          )}
          <motion.header
            initial={true}
            onClick={() => setSpecsOpen(!specsOpen)}
            className="cursor-pointer"
          >
            <motion.div
              animate={{ rotate: specsOpen ? 0 : 45 }}
              transition={{ duration: 0.35 }}
              initial={false}
            >
              <IconX />
            </motion.div>
          </motion.header>
        </div>
        <div className="hidden lg:block">
          <AnimatePresence initial={true}>
            <motion.section
              initial="collapsed"
              animate="open"
              exit="collapsed"
              variants={{
                open: { opacity: 1, height: 'auto' },
                collapsed: { opacity: 0, height: 0 }
              }}
              transition={{ duration: 0.8 }}
            >
              {order.map((title) => (
                <div
                  key={title}
                  className="flex flex-col lg:flex-row border-grey-300 pt-5 pb-3 lg:py-8 border-b"
                >
                  <div className="flex-1 text-sm lg:text-base text-white text-opacity-70 uppercase">
                    {splitTitle(title)}
                  </div>
                  {title === 'size_and_weight' ||
                  title === 'electrical_and_operating_requirements' ? (
                    title === 'size_and_weight' ? (
                      <div className="flex-1 flex flex-col">
                        {techSpecs[title]?.map((subtitle, index) => (
                          <div
                            key={subtitle}
                            className={`text-white text-sm lg:text-base order-${
                              sizeAndWeightOrder[Object.keys(subtitle)[0]]
                            } capitalize`}
                          >
                            {splitTitle(Object.keys(subtitle)[0])}
                            :&nbsp;
                            {techSpecs[title][index][Object.keys(subtitle)[0]]}
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="flex-1 flex flex-col">
                        {techSpecs[title]?.map((subtitle, index) => (
                          <div
                            key={subtitle}
                            className={`text-white text-sm lg:text-base order-${
                              electricalAndOperatingRequirementsOrder[
                                Object.keys(subtitle)[0]
                              ]
                            } capitalize`}
                          >
                            {splitTitle(Object.keys(subtitle)[0])}:&nbsp;
                            {techSpecs[title][index][Object.keys(subtitle)[0]]}
                          </div>
                        ))}
                      </div>
                    )
                  ) : (
                    <div className="flex-1 text-white text-sm lg:text-base">
                      {techSpecs[title]}
                    </div>
                  )}
                </div>
              ))}
            </motion.section>
          </AnimatePresence>
        </div>
        <div className="lg:hidden">
          <AnimatePresence initial={true}>
            {specsOpen && (
              <motion.section
                initial="collapsed"
                animate="open"
                exit="collapsed"
                variants={{
                  open: { opacity: 1, height: 'auto' },
                  collapsed: { opacity: 0, height: 0 }
                }}
                transition={{ duration: 0.8 }}
              >
                {order.map((title) => (
                  <div
                    key={title}
                    className="flex flex-col lg:flex-row border-grey-300 pt-5 pb-3 lg:py-8 border-b"
                  >
                    <div className="flex-1 text-sm lg:text-base text-white text-opacity-70 uppercase">
                      {splitTitle(title)}
                    </div>
                    {title === 'size_and_weight' ||
                    title === 'electrical_and_operating_requirements' ? (
                      title === 'size_and_weight' ? (
                        <div className="flex-1 flex flex-col">
                          {techSpecs[title]?.map((subtitle, index) => (
                            <div
                              key={subtitle}
                              className={`text-white text-sm lg:text-base order-${
                                sizeAndWeightOrder[Object.keys(subtitle)[0]]
                              } capitalize`}
                            >
                              {splitTitle(Object.keys(subtitle)[0])}
                              :&nbsp;
                              {
                                techSpecs[title][index][
                                  Object.keys(subtitle)[0]
                                ]
                              }
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div className="flex-1 flex flex-col">
                          {techSpecs[title]?.map((subtitle, index) => (
                            <div
                              key={subtitle}
                              className={`text-white text-sm lg:text-base order-${
                                electricalAndOperatingRequirementsOrder[
                                  Object.keys(subtitle)[0]
                                ]
                              } capitalize`}
                            >
                              {splitTitle(Object.keys(subtitle)[0])}:&nbsp;
                              {
                                techSpecs[title][index][
                                  Object.keys(subtitle)[0]
                                ]
                              }
                            </div>
                          ))}
                        </div>
                      )
                    ) : (
                      <div className="flex-1 text-white text-sm lg:text-base">
                        {techSpecs[title]}
                      </div>
                    )}
                  </div>
                ))}
              </motion.section>
            )}
          </AnimatePresence>
        </div>
      </div>
    </div>
  )
}
